import styled from 'styled-components';

export const OfferCard = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 16px 10px 16px 32px;
  border: none;
  opacity: 0.6;
  transition: all 0.2s ease;

  @media (max-width: 720px) {
    border-bottom: ${(props) =>
      props.lastElement ? 'none' : '1px solid #7070702e'};
  }
`;

export const LighteningDealRibbon = styled.div`
  background-image: linear-gradient(
    89deg,
    #44a56f,
    #71cb9a 6%,
    #70cb99 48%,
    #6fca98 94%,
    #44a56f 100%
  );
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  padding: 6px 22px 6px 10px;
  display: flex;
  align-items: center;
  position: absolute;
  height: 30px;
  width: max-content;
  top: -28px;
  left: 0;
  text-transform: uppercase;
  @media (max-width: 720px) {
    padding: 8px 18px 8px 8px;
    font-size: 10px;
    height: 20px;
    top: 6px;
    position: relative;
  }

  img {
    width: 9px;
    height: 11px;
    margin-right: 4px;
  }

  &:after {
    content: '';
    position: absolute;
    height: 0;
    width: 0;
    border-width: 15px 8px;
    border-style: solid;
    border-color: #70cb99 #f8fcff #70cb99 #70cb99;
    top: 0px;
    right: 0px;

    @media (max-width: 720px) {
      border-width: 10px 8px;
    }
  }
`;

export const CheckIcon = styled.span`
  width: 14px;
  height: 14px;
  display: inline-block;
  border: solid 1px #0101013d;
  border-radius: 50%;
  transition: 200ms linear;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    transform: scale(1.6);
    transition: 200ms linear;
    opacity: 0;
  }
`;

export const CardWrapper = styled.div`
  width: 100%;
  padding: 0 14px;
  margin: 8px 0;
  transition: 200ms linear;
  position: relative;

  @media (max-width: 720px) {
    margin: 0;
  }

  img {
    position: relative;
    top: 22px;
  }
`;

export const OfferName = styled.h4`
  font-size: clamp(17px, 2vw, 18px);
  color: hsl(0deg, 0%, 0%, 87%);
`;

export const PerDiaperPrice = styled.span`
  display: inline-block;
  background-color: #d9eae0;
  padding: 3px 8px;
  margin: 4px 0;
  font-size: 11px;
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 72%);
  width: max-content;
  border-radius: 3px;
`;

export const TemplateSection = styled.div`
  flex-basis: 44%;
  border: 2px dashed #63b0a8;
  border-radius: 6px;
  background: #fff;

  @media (max-width: 720px) {
    flex-basis: 100%;
    border: none;
    background: none;
  }
  .radioLabel {
    cursor: pointer;

    input[type='radio'] {
      display: none;

      &:checked + ${CardWrapper} {
        ${CheckIcon} {
          background: #ef4e5e;
          outline: 1px solid #ef4e5e;
          transform: scale(1.2);
          border: solid 2px #fff;
          width: 12px;
          height: 12px;

          &:before {
            transform: scale(1);
            opacity: 1;
          }
        }
        ${OfferCard} {
          opacity: 1;
        }
      }
    }

    @media (max-width: 720px) {
      cursor: default;
    }
  }
`;

export const RadioCustomButton = styled.div`
  position: absolute;
  left: 20px;
  top: 18px;
`;
